import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import MemberDataCaptureCurrent from 'Organisms/MemberDataCapture/MemberDataCaptureCurrent';
import useLink from 'Hooks/useLink';
import PropTypes from 'prop-types';

const MemberDataCaptureCurrentContainer = ({ relationship, onSubmit, readonly }) => {
  const link = relationship.link('related');
  const { collection, isInitializing, loadingError } = useLink(link);

  return (
    <DataContainer
      component={() => (
        <MemberDataCaptureCurrent
          isReadOnly={readonly}
          isInitializing={isInitializing}
          loadingError={loadingError}
          collection={collection}
          onSubmit={onSubmit}
        />
      )}
      loading={isInitializing}
      loadingError={loadingError}
    />
  );
};

MemberDataCaptureCurrentContainer.defaultProps = {
  readonly: false,
};

MemberDataCaptureCurrentContainer.propTypes = {
  relationship: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  readonly: PropTypes.bool,
};

export { MemberDataCaptureCurrentContainer };
